import { useQuery } from "@tanstack/react-query";
import { getApp } from "firebase/app";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { REGIONS_COLLECTION } from "src/constants/collectionsIds";

export default function useGetRegions() {
  return useQuery({
    queryKey: ["regions"],
    queryFn: async () => {
      const app = getApp();
      const db = getFirestore(app);
      const regionsColRef = collection(db, REGIONS_COLLECTION);
      const regionsSnapshot = await getDocs(regionsColRef);
      if (regionsSnapshot.empty) return { regions: [] };

      const regions = regionsSnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      return { regions };
    },
  });
}
